module.exports = __webpack_public_path__ + "img/arr4.9215ded9.svg";